import { Component, OnInit, ViewChild, ChangeDetectorRef, Renderer2, HostListener, Injector } from '@angular/core';
import { AlertController, IonSegment, ModalController, ToastController, NavParams } from '@ionic/angular';
import { StoreService, IStore, points } from '../../services/store.service';
import { GoogleApiService } from 'src/app/shared/services/google-api.service';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { IAddress } from 'src/app/shared/services/address.service';
//import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Geolocation } from '@capacitor/geolocation';
import { Storage } from '@ionic/storage';
import { AddressEditorModalComponent } from 'src/app/shared/components/address-editor-modal/address-editor-modal.component';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ListDialog } from '../../components/list-dialog/list-dialog.component';
//import { ScannerQRCodeResult } from 'ngx-scanner-qrcode';
import { IPlacePreOrderBase } from '../../services/preorder.service';
//import * as moment from 'moment';
import moment from 'moment';
import { TableOrderDetailsModalComponent } from '../../modals/table-order-details/table-order-details-modal.component';
import { ReservationService } from 'src/app/shared/services/reservation.service';
import { INotifications, NotificationServiceService } from '../../services/notification-service.service';
import { NotificationBellServiceService } from '../../services/notification-bell-service.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { SeatsModalComponent } from '../seats-modal/seats-modal.component';
import { MenuService } from '../../services/menu.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from 'src/app/shared/services/icon.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
const CACHE_KEY = 'cartStorage';


export type OrderType = 'delivery' | 'pickup' | 'shipping' | 'table' | 'seat' | null;


export interface IGeopoint {
  latitude: number;
  longitude: number;
}

@Component({
    selector: 'app-store-list-modal',
    templateUrl: './store-list-modal.component.html',
    styleUrls: ['./store-list-modal.component.scss'],
    standalone: false
})
export class StoreListModalComponent implements OnInit {
MAX_TABLE_ORDER_DISTANCE: number = 200;
  title: string = "Nav.Stores";
  stores: IStore[] = [];
  _stores: IStore[] = [];
  storeList: IStore[] = [];
  page: number = 1;
  pageSize: number = 20;
  orderType: OrderType = null;
  pickupValue: string;
  address: IAddress;
  segmentValue: string = 'address';
  isRetail: boolean=false;
  storeValidRange: IStore[] = [];
  storeValidTableOrderRange: IStore[] = [];
  doorDashDriveAverageRadius: number = 13;
  isDoorDashDrivePossible : boolean = false;
  showScanner: boolean = false;
  tableOrders: IPlacePreOrderBase[] = [];
  selectedDevice: MediaDeviceInfo;
  tableStoreId: string;
  tableNumber: number;
  hasNavigated: boolean = false;

  storeDisplay: number = 0;
  storeCap: number = 5;

  mobile: boolean = false;

  disableHeader: boolean = false;
  storeWithOrderItem: string[] = [];

  valideNotification: number;
  AllNotifications: INotifications[];

  unDockNavigationBar: boolean = false;

  clickedStoreId: string | number | null = null;

  newOrder: boolean = false;
  storeAtProceed: IStore;
  currentCartStore: IStore;

  get formatedAddress() {
    if (!this.address)
      return "";
    
    if (this.address.streetDirection == '' && this.address.streetType == '') {
      return `${this.address.streetNumber} ${this.address.street}, ${this.address.city}`;
    }

    if (this.address.streetDirection != undefined && this.address.streetDirection != '') {
      if (this.translationService.getLanguage().toLowerCase() == 'en') {
        return `${this.address.streetNumber} ${this.address.street} ${this.address.streetDirection} ${this.address.streetType}, ${this.address.city}`;
      } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
        return `${this.address.streetNumber} ${this.address.streetType} ${this.address.street} ${this.address.streetDirection}, ${this.address.city}`;
      }
      
    }

    if (this.translationService.getLanguage().toLowerCase() == 'en') {
      return `${this.address.streetNumber} ${this.address.street} ${this.address.streetType}, ${this.address.city}`;
    } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
      return `${this.address.streetNumber} ${this.address.streetType} ${this.address.street}, ${this.address.city}`;
    }
    

  }
  private _geopoint: IGeopoint;
  get geopoint(): IGeopoint {
    return this._geopoint;
  }

  set geopoint(value: IGeopoint) {
    this._geopoint = value;
    this.storeValidTableOrderRange = [];
    if (!value)
      return;

    this.stores.forEach(t => {
     
      t._distance = GeolocationHelpers.distance(value.latitude, value.longitude, t.address.latitude, t.address.longitude);
      
    })

    this._stores.forEach(t => {
      let d = GeolocationHelpers.distance(value.latitude, value.longitude, t.address.latitude, t.address.longitude);
      if(d <= this.MAX_TABLE_ORDER_DISTANCE){
        this.storeValidTableOrderRange.push(t);
      }
    });

    this.stores.sort((t, n) => t._distance - n._distance);
    this.resetStoreValidRange();
    this.stores.forEach(store => {
      this.isStoreRangeValid(store);
    });
  }

  get allowDelivery() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowDelivery;
    }
  }
  // get allowShipping()
  // { For Shipping

  // }
  get allowPickup() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowPickup;
    }
  }
  get allowShipping() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowShipping;
    }
  }

  get allowTable() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowTable;
    }
  }

  get allowSeat() {
    if (this.settingService.configuration) {
      return this.settingService.configuration.allowSeat;
    }
  }


  //@ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;

  @ViewChild(IonSegment)
  segment: IonSegment;

  menuDayPlaceholder: string;
  menuTimePlaceholder: string;

  bellIcon: IconDefinition;

  getCurrentPath(): string {
    return this.router.url;
  }

  constructor(private storeService: StoreService,
    private modalController: ModalController,
    private googleApiService: GoogleApiService,
    //private geolocation: Geolocation,
    private storage: Storage,
    private loaderService: LoaderService,
    public settingService: SettingService,
    private cdRef: ChangeDetectorRef,
    private alert: AlertService,
    //private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    public menuService: MenuService,
    private toastCtrl: ToastController,
    private dialog: MatDialog,
    private alertCtrl: AlertController,
    private reservationService: ReservationService,
    private injector: Injector,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private analytics: AnalyticsService,
    private iconService: IconService,
    public translationService: TranslationService
    ) {
      this.bellIcon = this.iconService.getIcon('bell')!;
    }

  async ngOnInit() {
    localStorage.setItem('Stateurl', 'popup-store');

    this.menuDayPlaceholder = this.translationService.translate('Menu.Placeholder.Day');
    this.menuTimePlaceholder = this.translationService.translate('Menu.Placeholder.Time');

    this.analytics.UpdateLocation({url: "/stores", ispopup: true},  true, false);

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }


     // Only access NavParams if running inside a modal
     const navParams = this.injector.get(NavParams, null);

    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
      }
    } catch (e) {

    }
    try {
      if(navParams.get('storeWithOrderItem') != undefined) {
        
        this.storeWithOrderItem = navParams.get('storeWithOrderItem');
      }
    } catch (e) {

    }

    if(this.settingService.configuration.uIoptions) {
      this.unDockNavigationBar = this.settingService.configuration.uIoptions?.unDockNavigationBar;
    }

    

    this.storage.remove('cart');
    this.isRetail = this.settingService.configuration.retailItems;
    //localStorage.setItem("deliveryAddress", null);
   // this.storage.remove("deliveryAddress");
    this.getStores();
    if(navParams.get('isTableOrder')){
      this.orderType = 'table';
    } else {
      const language = this.route.snapshot.paramMap.get('language');
   
      if(language) {
        if(language === 'en' || language ==='fr')
        { }
        else {
          this.router.navigate(['/stores'])
        }
      }

      this.storage.get('orderType').then(val=>{
        if(val) {
          if(val != 'seat'){
            this.changeOrderType(val);
          }
        }
      });

    }

    // by default, this is undefined as there doesn't seem to be a "tableOrders" in localStorage -- mathieu's note
    if(localStorage['tableOrders']){
      this.tableOrders = JSON.parse(localStorage['tableOrders']);
      if(this.tableOrders.length > 0){
        let now = new Date();
        let startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.tableOrders = this.tableOrders.filter(order => {
          if(order._store && order._store.tableOrderConfig && order._store.tableOrderConfig.clearTime != null && order._store.tableOrderConfig.clearTime != ""){
            let timeString = order._store.tableOrderConfig.clearTime;
            let timeParts = timeString.match(/(\d+):(\d+)(am|pm)/i);
            let hours = parseInt(timeParts[1]);
            let minutes = parseInt(timeParts[2]);
            let period = timeParts[3].toLowerCase();

            if (period === "pm" && hours < 12) {
                hours += 12;
            }
            if (period === "am" && hours === 12) {
                hours = 0;
            }

            startOfDay.setHours(hours, minutes, 0, 0);
            if(startOfDay > now){
              startOfDay.setDate(startOfDay.getDate() - 1);
            }
          }
          let orderDate = new Date(order._orderDate);
          return orderDate >= startOfDay
        });
        localStorage['tableOrders'] = JSON.stringify(this.tableOrders);
      }
    } 
    this.hasNavigated = false;


    // this defaults to taking whatever is available if
    const orderTypes = [
      ['pickup', this.allowPickup],
      ['delivery', this.allowDelivery],
      ['shipping', this.allowShipping],
      ['table', this.allowTable],
      ['seat', this.allowSeat],
    ] as const;

    const available = orderTypes.filter(([, enabled]) => enabled);

    const orderType: OrderType = available.length === 1 ? available[0][0] : null;
    if (orderType) {
      this.changeOrderType(orderType)
    }


    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  ngOnDestroy()
  {
    this.storage.remove('orderType');
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 

    if (window.innerWidth <= 500) { // follows the value of the modal
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }  

  validateClosing(store): boolean {
    if(((store._disabledPickup && this.orderType == 'pickup') || (store._disabledDelivery && this.orderType == 'delivery') || (store._disabled)) && !this.mobile) {
      return true;
    } else {
      return false;
    }
  }

  onTimeConfirm(store){
    // goes here if have required time active + chose asap, mimics original getLink
    if(!store._disabled && !this.menuService.order.orderTime){
      if(localStorage.getItem('orderDateTime') != null) {
        localStorage.removeItem('orderDateTime');
      }
      
      if(this.orderType !="delivery"){
        this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
      }else{
        if(!store.isDoorDashDrive){
          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
        }
      }

      return;
    }

    this.menuService.trackStoreId = store.id;

    const savedOrderDate = this.menuService.order.orderDate;
    
    this.menuService.timePickerChanged(store.id);

    const savedOrderTime = this.menuService.order.orderTime;
    const orderDateTime = { orderDate: savedOrderDate, orderTime: savedOrderTime };
    localStorage.setItem('orderDateTime', JSON.stringify(orderDateTime));



    this.clickedStoreId = null;
    this.menuService.trackStoreId = null;

    this.menuService.order._deliveryType = null;      

    this.menuService.order._deliveryType=null;
    this.menuService.menu = null;
    this.menuService.followingTime=null;
    this.menuService.followingDays.length=0;
    this.menuService.order.orderTime=null;
    this.menuService.order.orderDate=null;
    this.menuService.store = null;

    // we now allow doordash drive order for later
    //if (store.isDoorDashDrive && store._disabledDelivery && this.orderType == 'delivery') {
    //  return; //we dont want to let through a store delivery with doordash drive on order for later for now
    //}
    //Cache the delivery fees to access it later in the checkout processa
    localStorage.setItem("deliveryPrice", JSON.stringify(store.deliveryPrice));
    localStorage.setItem("convenienceFee", JSON.stringify(store.convenienceFee));
    if(store.isDoorDashDrive && this.orderType == 'delivery'){

      this.storeService.getDoorDashDriveEstimate(store.id, JSON.parse(localStorage.getItem("deliveryAddress"))).subscribe(async estimate=>{
        this.isDoorDashDrivePossible = estimate.isDeliveryPossible; 

        if(!this.isDoorDashDrivePossible){

          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.DoorDashDriveNotAvailable"),
            position: 'bottom',
            color: 'danger',
            cssClass: 'order-toast',
            buttons: [
              {
                side: 'start',
                icon: 'alert-circle-outline',
                //cssClass: 'order-error-icon',
                text: '',
                handler: () => {
        
                }
              }, {
                text: this.translationService.translate("General.Close"),
                role: 'cancel',
                handler: () => {
        
                }
              }
            ]
          });
          if(estimate.errorMessage.includes("address not within service area")){
            toast.message = this.translationService.translate("Checkout.DoorDashDriveEstimateTooFar");
          }
          await toast.present();
        
          this.stores.splice(this.stores.indexOf(store),1);     

        } else {
          //this.router.navigate(['/stores/menu', store.id, this.orderType]);
          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
          this.isDoorDashDrivePossible= false;
        }
      });
    
    
    }

    


    
    if(this.orderType !="delivery"){
        //this.router.navigate(['/stores/menu', store.id, this.orderType]);
        this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
    } else{
      if(!store.isDoorDashDrive){
        //this.router.navigate(['/stores/menu', store.id, this.orderType]);
        this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
      }
    }
    
  }

  storeMatchCartContent(store: IStore): boolean{
    if(this.storeWithOrderItem){
      if(this.storeWithOrderItem.length > 0){
        // simply cycle through all the id's that are in in this array with the stores and return true if it contains it or false if it doesn't
        if(this.storeWithOrderItem.includes(store.id)) {
          return true;
        } else {
          return false;
        }
      }
    }

    return true;
  }

  // simply modifies the show more to match the new values when looking at specific stores
  showMoreStoreRangeComparison(): boolean{
    if(this.storeWithOrderItem){
      if(this.storeWithOrderItem.length > 0){
        var countValidSTores = 0;

        for (var i = 0; i < this.storeValidRange.length; i++) {
          if(this.storeWithOrderItem.includes(this.storeValidRange[i].id)) {
            countValidSTores++;
          }
        }

        if(countValidSTores > this.storeCap) {
          return true;
        } else {
          return false;
        }
      }
    }
    return true;
  }

  getStoreAddress(storeAddress){
    //var addressStr = storeAddress.street + ", " + storeAddress.city;
    var addressStr = storeAddress.streetNumber + ", " + storeAddress.street;
    /*
    if(window.innerWidth <= 500) {
      addressStr = storeAddress.city;
    }
    */
    
    return addressStr;
  }

  async getStores() {
    const loader = await this.loaderService.create();

    this.storeService.getStores(false, "standard")
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((data: IStore[]) => {
        this.stores = data;
        this._stores = data;
        this.stores.forEach(store => {
          this.showOpeningHours(store);         
        });
        if(this.router.url.split('/').pop() == "table-order"){
          this.setValidStoresPosition();
        }
      });
  }

  async segmentChanged() {
    
      if(this.segment)
      {
        this.segmentValue = String(this.segment.value);
        //this.segmentValue = this.segment.value;
        
      }
    if (this.segmentValue == 'position') {
      this.setValidStoresPosition();
    } else if (this.segmentValue == 'address' || this.segmentValue == '') {
      this.geopoint = null;

      if (this.address) {
        this.googleApiService.getAddressGeometry(this.address)
          .subscribe((result) => {
            this.geopoint = {
              latitude: result.lat,
              longitude: result.lng
            }
           
            this.stores.forEach(store => {
              store = this.storeService.setDeliveryPrice(store, this.address, this.geopoint);
            });

          });
      }
    }

    //recently added (mathieu)
    this.storeCap = 5;
  }

  async changeOrderType(orderType: OrderType) {
    this.orderType = orderType;
    this.storeValidRange = [];
    if (this.orderType == 'delivery' && this.segment) {
      this.segment.value = 'address';
      if(this.address){
        localStorage.setItem("deliveryAddress", JSON.stringify(this.address));
      }
    }

    if (this.orderType == 'shipping' && this.segment) {
      this.segment.value = 'address';
      if(this.address){
        localStorage.setItem("shippingAddress", JSON.stringify(this.address));
      }
    }

    if(this.orderType == 'table') {
      this.setValidStoresPosition();
    }

    if(this.orderType == 'seat'){
      let s = this.modalController;

      const modal = await this.modalController.create({
        component: SeatsModalComponent,
        componentProps: {
          store: this.stores[6]
        }
      });

      modal.onWillDismiss()
      .then((result) => {
        if (result.data) { 
          // right now client only has 1 store so no need to implement logic for multiple stores
          let store = this.stores.find(t => t.id == "60896002697c5968a801c44d" || t.id == "5f5777582e42540001040de3");
          if(store){
            this.stores = [store];
          }
          if(this.stores.length == 1){
            
            this.router.navigate(['/stores/menu', this.stores[0].id, this.orderType],
              {
                queryParams: { section: result.data.section,  row: result.data.row, seatNumber: result.data.seatNumber }
              }).then(() => {
                // Now dismiss all modals aka the current and the parent modal
                this.dismissAllModals();
              });
          }
        } 
      });
  
      await modal.present();
    }

    

    if(this.orderType == 'pickup') {
      if(this.settingService.configuration.locationFiltering == 1) {
        this.segmentValue = 'position';
        this.pickupValue = 'position';
        this.segmentChanged();
      } else if(this.settingService.configuration.locationFiltering == 0) {
        this.pickupValue='address';
        this.segmentValue='address';
        this.segmentChanged();
      }

    } else {

      this.pickupValue='address';
      this.segmentValue='address';
      this.segmentChanged();
    }

    //validate if store is allowed for that delivery type
    //Filter stores depending on the delivery mode
    this.storeList = this._stores.filter((a) => {
      
       //Adding new validation to check if the resto offer delivery/pickup according to the current day
    var allowed = true;
   /*    if ((this.orderType == 'pickup' && !a._todayOfferPickup)
    || (this.orderType == 'delivery' && !a._todayOfferDelivery)) {
      allowed = false;
    }
*/
      //Remove a store from the list when it is turned off by seemystore.
      //10-05-2021: Not doing the safety to automatically unblock a store (job) as requested by Anthony even if it was designed this way when the config was created.
      if(this.orderType == "delivery"){
        if (allowed && (!a.acceptingOrders && !a.acceptingDeliveryOrders)) {
          return false;
        }
      } else if (this.orderType == "pickup"){
        if (allowed && (!a.acceptingOrders && !a.acceptingPickupOrders)) {
          return false;
        }
      }
      /*
      if (allowed) {
        return ((a.allowDelivery && (this.orderType == "delivery" || this.orderType=="shipping"))//temp fix
        || (a.allowPickup && this.orderType == "pickup"))
      } else {
        return allowed;
      }
      */
      if (allowed) {
        return ((a.allowDeliveryBrowser && this.orderType == "delivery")//temp fix
        || (a.allowPickupBrowser && this.orderType == "pickup")
        || (a.allowShippingBrowser && this.orderType == "shipping")
        || this.orderType == "seat")
      } else {
        return allowed;
      }
    });
   
    this.stores = this.storeList;
    if(this.address){
      this.resetStoreValidRange();
      this.stores.forEach((store, index) => {
        this.isStoreRangeValid(store);
        store = this.storeService.setDeliveryPrice(store, this.address,this.geopoint);
        if(index == this.stores.length - 1){
          this.stores = this.storeValidRange.sort((t, n) => t._distance - n._distance);
        }
      });
    }

    if(this.orderType == "delivery" || this.orderType == "pickup"){
      var storedStoreId = localStorage['StoreId'];
      if(this.stores.find(s => s.id == storedStoreId) != null && localStorage['cartStorage'] != undefined){
        var storedCarts = JSON.parse(localStorage['cartStorage']);
        if(storedCarts && storedCarts.length == 1){
          storedCarts.map(cart => {
            if(cart.orderType != this.orderType && cart.orderType != "shipping" && cart.orderType != "table" && cart.orderType != "seat"){
              let dialogWidth: number = 350;
              let contentWidth = document.getElementById('ion-content').offsetWidth;
              let gridWidth = document.getElementById('ion-grid').offsetWidth;
              let rightPosition = contentWidth/2 - dialogWidth/2 + (contentWidth-gridWidth)/2;

              const dialogRef = this.dialog.open(ListDialog, {
                width: dialogWidth + "px",
                data: {orderType: this.orderType},
                position: (contentWidth < 440) ? {} : {right: rightPosition + 'px'},
                autoFocus: false 
              });
          
              dialogRef.afterClosed().subscribe(move => {
                if(move){
                  storedCarts.map(cart => {
                    cart.orderType = this.orderType;
                  })
                  localStorage.setItem('cartStorage', JSON.stringify(storedCarts));
                }
                this.skipStoreSelection();
              }); 
            }
          });
        } else {
          this.skipStoreSelection();
        }
      } else {
        this.skipStoreSelection();
      }
    }

    
  }

  async dismissAllModals() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss(null, null, topModal.id);
      
      // Wait a short delay to ensure the modal is truly dismissed before checking again
      setTimeout(() => {
        this.dismissAllModals();
      }, 100); // 100ms is usually enough
    }
  }

  skipStoreSelection(skipCheckForShipping: boolean = false){
    if(skipCheckForShipping) {
      if (this.settingService.configuration.skipStoreSelection && (/*this.orderType == "delivery" || */this.orderType == "shipping") && this.stores.length == 1){
        this.router.navigate(['/stores/menu', this.stores[0].id, this.orderType]);
      }
    } else {
      if (this.settingService.configuration.skipStoreSelection && (this.orderType == "pickup" || this.orderType == "seat") && this.stores.length == 1){
        this.router.navigate(['/stores/menu', this.stores[0].id, this.orderType]);
      }
    }
    
  }

  getOrderTypeColor(orderType: OrderType) {
    if (orderType == this.orderType)
      return 'primary';

    return undefined;
  }

  async beginChangeAddress() {
    const modal = await this.modalController.create({
      component: AddressEditorModalComponent,
      componentProps: {
        title: 'Store.Address',
        skipProvinceValidation: true
      }
    });

    modal.onWillDismiss()
      .then((result) => {
        if (result.data) {     
          this.stores = this.storeList;
          this.resetStoreValidRange();
         
          this.address = result.data;
          this.filterStoresOnPostalCode();

          this.googleApiService.getAddressGeometry(result.data)
            .subscribe((result) => {
              this.geopoint = {
                latitude: result.lat,
                longitude: result.lng
              }

              this.googleApiService.getCountry(this.geopoint).subscribe((country) => {
                this.address.country = country;
                 //Cache the delivery address to access it later in the checkout process
                 if(this.orderType == "delivery"){
                  localStorage.setItem("deliveryAddress", JSON.stringify(this.address));
                 } else if (this.orderType == "shipping"){
                  localStorage.setItem("shippingAddress", JSON.stringify(this.address));
                 }
              });

              this.resetStoreValidRange();
              
              this.stores.forEach( (store, index) => {
                this.isStoreRangeValid(store);
                store = this.storeService.setDeliveryPrice(store, this.address,this.geopoint);
                if(index == this.stores.length - 1){
                  this.stores = this.storeValidRange.sort((t, n) => t._distance - n._distance);
                }
              });
            });
        }
      });

    await modal.present();
  }

  getMinutes(str: string) {
    let partOfDay: string = str.substring(str.length - 2);
    let timeOnly: any = str.substring(0, str.length - 2);

    if (partOfDay == "pm") {
      timeOnly = parseFloat(timeOnly) + 12;
      timeOnly = timeOnly.toString();
    }

    if (partOfDay != "am" && partOfDay != "pm") {
      timeOnly = str;
    }

    let time: string[] = timeOnly.split(':');

    return (parseFloat(time[0]) * 60) + (parseFloat(time[1]) * 1);
  }

  getMinutesNow() {
    let timeNow = new Date();
    return timeNow.getHours() * 60 + timeNow.getMinutes();
  }

  showOpeningHours(store: IStore) {
    this.storeService.setOpeningHours(store);
  }

  /*checkStatus(event: Event, store: IStore) {
    if (store._disabled) {
      event.preventDefault();
    }
  }*/
 
  

  getLink(store: IStore, orderType: string, StoreClosed) {
    //await this.storeClicked(store);


    if(!StoreClosed && !this.settingService.configuration.requireTimeOfOrder) {

      if(localStorage.getItem('orderDateTime') != null) {
        localStorage.removeItem('orderDateTime');
      }
      
      if(orderType != "delivery"){

        this.modalController.dismiss({ route: '/menu/' + store.id + '/' + orderType });
        //return ['./menu', store.id, orderType];
      } else{
        if(!store.isDoorDashDrive){
          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + orderType });
          //return ['./menu', store.id, orderType];
        }
      }
      
    }
  }

  isStoreRangeValid(store: IStore) {
    if(this.storage['previewMenuMode']){
      this.storeValidRange.push(store);
      return true;
    }  
    if (this.orderType == "pickup" || this.orderType == "shipping") {
      this.storeValidRange.push(store);
      return true;
    }


    //First we priorize the postal code validation
    if (this.address) {

     // if(store.isDoorDashDrive &&  this.orderType =="delivery"){

      
    
      // if(store._distance <= this.doorDashDriveAverageRadius){
      //     this.storeValidRange.push(store);
      //     return true;
      //   }
      //   return false;

       
      // }
      //debugger;



      ///////////////////////////////////////////////
      // currently testing
      if (store.postalCodesDelivery && store.postalCodesDelivery.length > 0) {

        let found = store.postalCodesDelivery.indexOf(this.address.postalCode) > -1;
        if (found) {
  
          this.storeValidRange.push(store);

        }
       
    
        return found;


        /*this._stores.forEach(t => {
          if (t.postalCodesDelivery && t.postalCodesDelivery.length > 0) {
            let test = this._stores.filter(t => { 
              if (t.postalCodesDelivery != null) {
                return t.postalCodesDelivery.indexOf(this.address.postalCode) > -1;
              }         
            })
    
            this.stores = test;
          }
        })*/
      }
      ///////////////////////////////////////////////////


      ///////////////////////////////////////////////////

      if(store.deliveryZone && store.deliveryZone.deliveryZone != null && store.deliveryZone.deliveryZone.length > 0){
        //need to find a point for the current address to compare with the points
        //console.log(store);

        let found = false;
        store.deliveryZone.deliveryZone.forEach(zone => {
          if(this.storeService.inside(this.geopoint, zone.points)){
           
            this.storeValidRange.push(store);
            found = true;
          }
        });

        //console.log(found);
        return found;
      }
    }
    /////////////////////////////////////////////////////



    /////////////////////////////////////////////////////
    //

    //the radius is only taken in reference when no postal code are supplied
    //|| ( store.isDoorDashDrive &&  this.orderType =="delivery" && store._distance <=  this.doorDashDriveAverageRadius)
    if (store._distance <= store.deliveryRadius ) {

      this.storeValidRange.push(store);
      return true;
    }
    ////////////////////////////////////////////////////
  
    return false;
  }

  /*
  async storeClicked(store: IStore) {

    //this.getLink(store, this.orderType, store._disabled);
    if(this.settingService.configuration.requireTimeOfOrder && !store._disabled && this.clickedStoreId != store.id){
      this.clickedStoreId = store.id;
      this.menuService.trackStoreId = store.id;

      if(this.orderType)
      {
        this.menuService.order._deliveryType = this.orderType;      
      
      } else {
        this.menuService.order._deliveryType=null;
      }

      this.menuService.menu = null;
      this.menuService.followingTime=null;
      this.menuService.followingDays.length=0;
      this.menuService.order.orderTime=null;
      this.menuService.order.orderDate=null;
      this.menuService.store = null;

      //console.log(store);

      await this.menuService.getStore(store.id);

      this.menuService.datePickerChanged(this.orderType);

      return;   
    }

    // we now allow doordash drive order for later
    //if (store.isDoorDashDrive && store._disabledDelivery) {
    //  return; //we dont want to let through a store delivery with doordash drive on order for later for now
    //}

    

    // we'll track here whether an order exist and if it's at a different store
    if(!store._disabled) {
      if(localStorage[CACHE_KEY]) {
        // here we restore the items back from cache. we'll do 2 things. 1 check if all items are from this store, if even 1 items isn't, it'll reset the cart.
        var cachedItemList = JSON.parse(localStorage[CACHE_KEY]);
        var currentStore = store.id;

        var differentStoreItem = cachedItemList.find(
          item => item._relatedStoreId !== currentStore
        );

        if(differentStoreItem) {
          // trigger a modal that asks if they want to proceed which will delete their order
          this.newOrder = true;
          this.storeAtProceed = store;

          // get the store related to the storeId
          const relatedStoreId = differentStoreItem._relatedStoreId;
          const CurrentCartStore = this.stores.find(
            ItemStore => ItemStore.id == relatedStoreId
          );
          this.currentCartStore = CurrentCartStore;


          return;
        } else {
          this.goToStoreMenuPage(store);
        }
      } else {
        this.goToStoreMenuPage(store);
      }
    }


    //return this.getLink(store, orderType);
  }
  */

  async storeClicked(store: IStore) {

    this.getLink(store, this.orderType, store._disabled);


    if(store._disabled && this.clickedStoreId != store.id) {

      this.clickedStoreId = store.id;
      this.menuService.trackStoreId = store.id;

      if(this.orderType)
      {
        this.menuService.order._deliveryType = this.orderType;

      } else {
        this.menuService.order._deliveryType = null;
      }

      this.menuService.menu = null;
      this.menuService.followingTime = null;
      this.menuService.followingDays.length = 0;
      this.menuService.order.orderTime = null;
      this.menuService.order.orderDate = null;
      this.menuService.store = null;

      await this.menuService.getStore(store.id);

      this.menuService.datePickerChanged(this.orderType);

      return;
    }

    if(this.settingService.configuration.requireTimeOfOrder && !store._disabled && this.clickedStoreId != store.id){
      this.clickedStoreId = store.id;
      this.menuService.trackStoreId = store.id;

      if(this.orderType)
      {
        this.menuService.order._deliveryType = this.orderType;

      } else {
        this.menuService.order._deliveryType=null;
      }

      this.menuService.menu = null;
      this.menuService.followingTime=null;
      this.menuService.followingDays.length=0;
      this.menuService.order.orderTime=null;
      this.menuService.order.orderDate=null;
      this.menuService.store = null;

      //console.log(store);

      await this.menuService.getStore(store.id);

      this.menuService.datePickerChanged(this.orderType);

      return;
    }

    // we now allow doordash drive order for later
    //if (store.isDoorDashDrive && store._disabledDelivery) {
    //  return; //we dont want to let through a store delivery with doordash drive on order for later for now
    //}



    //Cache the delivery fees to access it later in the checkout processa
    localStorage.setItem("deliveryPrice", JSON.stringify(store.deliveryPrice));
    localStorage.setItem("convenienceFee", JSON.stringify(store.convenienceFee));
    if(store.isDoorDashDrive && this.orderType == 'delivery'){

      this.storeService.getDoorDashDriveEstimate(store.id, JSON.parse(localStorage.getItem("deliveryAddress"))).subscribe(async estimate=>{
        this.isDoorDashDrivePossible = estimate.isDeliveryPossible;

        if(!this.isDoorDashDrivePossible){

          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.DoorDashDriveNotAvailable"),
            position: 'bottom',
            color: 'danger',
            cssClass: 'order-toast',
            buttons: [
              {
                side: 'start',
                icon: 'alert-circle-outline',
                //cssClass: 'order-error-icon',
                text: '',
                handler: () => {

                }
              }, {
                text: this.translationService.translate("General.Close"),
                role: 'cancel',
                handler: () => {

                }
              }
            ]
          });
          if(estimate.errorMessage.includes("address not within service area")){
            toast.message = this.translationService.translate("Checkout.DoorDashDriveEstimateTooFar");
          }
          await toast.present();

          this.stores.splice(this.stores.indexOf(store),1);

        } else {
          //this.router.navigate(['/stores/menu', store.id, this.orderType]);

          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
          this.isDoorDashDrivePossible= false;
        }
      });


    }

    //return this.getLink(store, orderType);
  }

  goToStoreMenuPage(store: IStore) {
    //Cache the delivery fees to access it later in the checkout processa
    localStorage.setItem("deliveryPrice", JSON.stringify(store.deliveryPrice));
    localStorage.setItem("convenienceFee", JSON.stringify(store.convenienceFee));
    if(store.isDoorDashDrive && this.orderType == 'delivery'){

      this.storeService.getDoorDashDriveEstimate(store.id, JSON.parse(localStorage.getItem("deliveryAddress"))).subscribe(async estimate=>{
        this.isDoorDashDrivePossible = estimate.isDeliveryPossible; 

        if(!this.isDoorDashDrivePossible){

          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.DoorDashDriveNotAvailable"),
            position: 'bottom',
            color: 'danger',
            cssClass: 'order-toast',
            buttons: [
              {
                side: 'start',
                icon: 'alert-circle-outline',
                //cssClass: 'order-error-icon',
                text: '',
                handler: () => {
        
                }
              }, {
                text: this.translationService.translate("General.Close"),
                role: 'cancel',
                handler: () => {
        
                }
              }
            ]
          });

          if(estimate.errorMessage.includes("address not within service area")){
            toast.message = this.translationService.translate("Checkout.DoorDashDriveEstimateTooFar");
          }

          await toast.present();
        
          this.stores.splice(this.stores.indexOf(store),1);     

          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
        } else {
          this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
          this.isDoorDashDrivePossible = false;
        }
      });
    
    
    } else {
      this.modalController.dismiss({ route: '/menu/' + store.id + '/' + this.orderType });
    }
  }

  emptyOrderAndGoToStore() {

    this.newOrder = false;

    localStorage.removeItem(CACHE_KEY);
    localStorage.removeItem("TimeLimit");
    localStorage.removeItem("cartStorage");
    localStorage.removeItem("StoreId");
    this.menuService.order.orderItems = [];


    //Cache the delivery fees to access it later in the checkout processa
    localStorage.setItem("deliveryPrice", JSON.stringify(this.storeAtProceed.deliveryPrice));
    localStorage.setItem("convenienceFee", JSON.stringify(this.storeAtProceed.convenienceFee));
    if(this.storeAtProceed.isDoorDashDrive && this.orderType == 'delivery'){

      this.storeService.getDoorDashDriveEstimate(this.storeAtProceed.id, JSON.parse(localStorage.getItem("deliveryAddress"))).subscribe(async estimate=>{
        this.isDoorDashDrivePossible = estimate.isDeliveryPossible; 

        if(!this.isDoorDashDrivePossible){

          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.DoorDashDriveNotAvailable"),
            position: 'bottom',
            color: 'danger',
            cssClass: 'order-toast',
            buttons: [
              {
                side: 'start',
                icon: 'alert-circle-outline',
                //cssClass: 'order-error-icon',
                text: '',
                handler: () => {
        
                }
              }, {
                text: this.translationService.translate("General.Close"),
                role: 'cancel',
                handler: () => {
        
                }
              }
            ]
          });

          if(estimate.errorMessage.includes("address not within service area")){
            toast.message = this.translationService.translate("Checkout.DoorDashDriveEstimateTooFar");
          }

          await toast.present();
        
          this.stores.splice(this.stores.indexOf(this.storeAtProceed),1);     

          this.modalController.dismiss({ route: '/menu/' + this.storeAtProceed.id + '/' + this.orderType });
        } else {
          this.modalController.dismiss({ route: '/menu/' + this.storeAtProceed.id + '/' + this.orderType });
          this.isDoorDashDrivePossible= false;
        }
      });
    } else {
      this.modalController.dismiss({ route: '/menu/' + this.storeAtProceed.id + '/' + this.orderType });
    }
  }

  closeWarning() {
    // changed so that we actually resume but to the store that has the items in our cart
    this.newOrder = false;



    //Cache the delivery fees to access it later in the checkout processa
    localStorage.setItem("deliveryPrice", JSON.stringify(this.currentCartStore.deliveryPrice));
    localStorage.setItem("convenienceFee", JSON.stringify(this.currentCartStore.convenienceFee));
    if(this.currentCartStore.isDoorDashDrive && this.orderType == 'delivery'){

      this.storeService.getDoorDashDriveEstimate(this.currentCartStore.id, JSON.parse(localStorage.getItem("deliveryAddress"))).subscribe(async estimate=>{
        this.isDoorDashDrivePossible = estimate.isDeliveryPossible; 

        if(!this.isDoorDashDrivePossible){

          const toast = await this.toastCtrl.create({
            message: this.translationService.translate("Checkout.DoorDashDriveNotAvailable"),
            position: 'bottom',
            color: 'danger',
            cssClass: 'order-toast',
            buttons: [
              {
                side: 'start',
                icon: 'alert-circle-outline',
                //cssClass: 'order-error-icon',
                text: '',
                handler: () => {
        
                }
              }, {
                text: this.translationService.translate("General.Close"),
                role: 'cancel',
                handler: () => {
        
                }
              }
            ]
          });

          if(estimate.errorMessage.includes("address not within service area")){
            toast.message = this.translationService.translate("Checkout.DoorDashDriveEstimateTooFar");
          }

          await toast.present();
        
          this.stores.splice(this.stores.indexOf(this.currentCartStore),1);     

          this.router.navigate(['/stores/menu', this.currentCartStore.id, this.orderType]);

        } else {
          this.router.navigate(['/stores/menu', this.currentCartStore.id, this.orderType]);
          this.isDoorDashDrivePossible= false;
        }
      });
    } else {
      this.router.navigate(['/stores/menu', this.currentCartStore.id, this.orderType]);
    }
  }

  closeScanner(){
    this.showScanner = false;
  }

  toggleScanner(){
    this.showScanner = !this.showScanner;
  }

  // https://stackblitz.com/edit/angular-ngx-scanner-qrcode?file=src%2Fapp%2Fapp.component.ts,src%2Fapp%2Fapp.component.html
  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find(f => (/back|rear|environment/gi.test(f.label))); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    }

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe();
    } else {
      action[fn]().subscribe();
    }
  }

  // created a potential replacement (qr-scanner.component)
  /*
  onScannerEvent(e: ScannerQRCodeResult[], action?: any): void {
    if(e[0].value.startsWith("https://")){
      window.location.href = e[0].value; 
    }
  }
  */

  scanSuccessHandler(result: string){
    if (!this.hasNavigated) {
      if(result.startsWith("https://")){
        this.hasNavigated = true;
        window.location.href = result; 
      }
    }

    if(result.startsWith("https://")){
      window.location.href = result; 
    }
  }

  getLocalDate(date: string){
    let localDate = moment.utc(date).local();
    return localDate.format('h:mma');
  }

  async setValidStoresPosition(){
    this.geopoint = null;

    const loader = await this.loaderService.create();
    await loader.present();

    /*
    this.geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 20000 })
      .then(position => {
        this.geopoint = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }
      })
      .catch((reason) => {
        let messageKey;
        if (reason.code == 1) //PositionError.PERMISSION_DENIED)
          messageKey = 'Geolocation.PermissionDenied';
        else if (reason.code == 2) //PositionError.POSITION_UNAVAILABLE)
          messageKey = 'Geolocation.PositionUnavailable';
        else if (reason.code == 3) //PositionError.TIMEOUT)
          messageKey = 'Geolocation.Timeout';

        if (messageKey)
          this.alert.showTranslate(messageKey);
        else
          this.alert.showUnexpectedErrorMsg();
      })
      .finally(() => {
        loader.dismiss();
      });
      */



      /*
      Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 20000
      })
        .then(position => {
          this.geopoint = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };

        })
        .catch(reason => {
          let messageKey;

          // Capacitor uses the same PositionError codes as W3C:
          // 1: PERMISSION_DENIED
          // 2: POSITION_UNAVAILABLE
          // 3: TIMEOUT

          if (reason.code === 1)
            messageKey = 'Geolocation.PermissionDenied';
          else if (reason.code === 2)
            messageKey = 'Geolocation.PositionUnavailable';
          else if (reason.code === 3)
            messageKey = 'Geolocation.Timeout';

          if (messageKey)
            this.alert.showTranslate(messageKey);
          else
            this.alert.showUnexpectedErrorMsg();
        })
        .finally(() => {
          loader.dismiss();
        });
        */

    try {
      const position = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 5000
      });

      this.setCoords(position);
      loader.dismiss();

    } catch (highAccuracyError) {
      console.warn('High accuracy failed, falling back...', highAccuracyError);

      try {
        const position = await Geolocation.getCurrentPosition({
          enableHighAccuracy: false,
          timeout: 5000
        });

        this.setCoords(position);
        loader.dismiss();

      } catch (fallbackError) {
        this.handleGeoError(fallbackError);
        loader.dismiss();
      }
    }
  }

  setCoords(position: any) {
    this.geopoint = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };
  }

  handleGeoError(reason: any) {
    let messageKey;

    if (reason.code === 1)
      messageKey = 'Geolocation.PermissionDenied';
    else if (reason.code === 2)
      messageKey = 'Geolocation.PositionUnavailable';
    else if (reason.code === 3)
      messageKey = 'Geolocation.Timeout';

    if (messageKey)
      this.alert.showTranslate(messageKey);
    else
      this.alert.showUnexpectedErrorMsg();
  }

  openTableMenu(){
    if(this.tableStoreId == undefined){
      this.alertCtrl.create({
        message: "Please provide a location",
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
            cssClass: 'secondary'
          }
        ]
      }).then(al=>{
        al.present();
      });
    } else if (this.tableNumber == undefined || isNaN(parseFloat(this.tableNumber.toString())) ){
      this.alertCtrl.create({
        message: "Please provide a valid table number",
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
            cssClass: 'secondary'
          }
        ]
      }).then(al=>{
        al.present();
      });
    } else {
      this.reservationService.getTable(null, this.tableStoreId, parseFloat(this.tableNumber.toString())).subscribe((table) => {
        if(table != null){
          this.router.navigate([`/menu/${this.tableStoreId}/${table.id}/table`]);
        } else {
          this.alertCtrl.create({
            message: "Invalid location & table number combination",
            buttons: [
              {
                text: 'Ok',
                role: 'cancel',
                cssClass: 'secondary'
              }
            ]
          }).then(al=>{
            al.present();
          });
        }
      });
    }
  }

  async openOrder(order: IPlacePreOrderBase){
    const modal = await this.modalController.create({
      component: TableOrderDetailsModalComponent,
      componentProps: {
        order: order,
        store: order._store,
      }
    });

    modal.present();
  }

  private resetStoreValidRange() {
    this.storeValidRange = [];
  }

  private filterStoresOnPostalCode() {
    //just do the validation in the other condition, must not validate a 2 different place
    /*  debugger;
      this._stores.forEach(t => {
        if (t.postalCodesDelivery && t.postalCodesDelivery.length > 0) {
          let test = this._stores.filter(t => { 
            if (t.postalCodesDelivery != null) {
              return t.postalCodesDelivery.indexOf(this.address.postalCode) > -1;
            }         
          })
  
          this.stores = test;
        }
      })*/
  }

  /*loadData(event) {
    setTimeout(async() => {
      this.storeService.getStores(this.page, this.pageSize)
      .subscribe(data => {
        this.stores = data;

        console.log(this.stores.length);

        this.page += 1;
        event.target.complete();
        
        if (this.stores.length segmentChanged>= 1000)
          event.target.disabled = true;

        this.infiniteScroll.disabled = false;
      });
    }, 1000);
  }

  toggleInfiniteScroll() {
    this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
  }*/

  public incrementStore(data?){
    this.storeDisplay += 1;
  }

  public incrementStoreReset() {
    this.storeDisplay = 0;
  }

  public showMoreStore() {
    this.storeCap += 5;
  }

  closePopup(){
    this.modalController.dismiss();
  }
}
